import React, { useEffect, useState } from "react";
import { getDentistWiseAppointments, DentistAppointment } from "../../../api/dashboardService";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventIcon from "@mui/icons-material/Event";

const now = new Date();
const formattedDate = `${String(now.getDate()).padStart(2, "0")}-${String(
  now.getMonth() + 1
).padStart(2, "0")}-${now.getFullYear()}`;

function DoctorAppointment() {
  const [appointments, setappointments] = useState<DentistAppointment[]>([]);

  useEffect(() => {
    getDentistWiseAppointments()
      .then((result) => {
        setappointments(result);
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);

  return (
    <div className="rounded-2xl shadow-lg border overflow-hidden transition-all duration-300 bg-white border-slate-100 shadow-slate-200/50 dark:bg-slate-800 dark:border-slate-700 dark:shadow-slate-900/50">
      {/* Header */}
      <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center">
            <LocalHospitalIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-800 dark:text-slate-100">
              Dentist Wise Appointments
            </h3>
            <p className="text-sm text-slate-500 dark:text-slate-400">Today's schedule</p>
          </div>
        </div>
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-slate-100 dark:bg-slate-700">
          <CalendarTodayIcon className="text-slate-500 dark:text-slate-400" sx={{ fontSize: 16 }} />
          <span className="text-sm font-medium text-slate-600 dark:text-slate-300">{formattedDate}</span>
        </div>
      </div>

      {/* Dentist Cards */}
      <div className="p-6">
        {appointments?.length === 0 ? (
          <div className="text-center py-8 text-slate-400 dark:text-slate-500">
            <LocalHospitalIcon sx={{ fontSize: 48 }} className="mb-2" />
            <p>No appointments today</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {appointments?.map((item, index) => (
              <div
                key={index}
                className="rounded-xl p-4 border hover:shadow-md transition-all duration-300 bg-gradient-to-br from-slate-50 to-slate-100 border-slate-200 dark:from-slate-700 dark:to-slate-800 dark:border-slate-600"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-md">
                    {item?.firstName?.charAt(0)?.toUpperCase()}
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 dark:text-slate-100">
                      Dr. {item?.firstName} {item?.lastName}
                    </p>
                    <p className="text-xs text-slate-500 dark:text-slate-400">Dentist</p>
                  </div>
                </div>
                <div className="flex items-center justify-between rounded-lg px-3 py-2 bg-white dark:bg-slate-700/50">
                  <div className="flex items-center gap-2">
                    <EventIcon className="text-emerald-500" sx={{ fontSize: 18 }} />
                    <span className="text-sm text-slate-600 dark:text-slate-300">
                      {item?.count === 1 ? "Appointment" : "Appointments"}
                    </span>
                  </div>
                  <span className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">
                    {item?.count}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DoctorAppointment;
